import { AxiosClient } from "./AxiosClient";

export const getSignals = () => {
  try {
    return AxiosClient.get("signals/getAllSignals");
  } catch (e) {
    console.log(e);
  }
};

export const getSignalPosts = (target, { start, end }) => {
  try {
    return AxiosClient.post("signals/getSignalPosts", { target, start, end });
  } catch (e) {
    console.log(e);
  }
};

export const getSignalMinMaxDate = (target) => {
  try {
    return AxiosClient.post("signals/getSignalsTimelineMinMax", { target });
  } catch (e) {
    console.log(e);
  }
};

export const saveSignal = (caseName, prompt) => {
  try {
    return AxiosClient.post("cases/saveSignal", { caseName, prompt });
  } catch (e) {
    console.log(e);
  }
};
